import tusUploader from './index';

export function configTusUploader(teamName) {
  tusUploader.options.headers = {
    'X-ByteArk-Team': teamName,
  };
}
